import Button from "./Button.vue"
export default Button